module.exports = __webpack_public_path__ + "img/stegi-radio-logo-black.8896695b.svg";